export default __webpack_public_path__ + "static/dummyFive-c19c98380157b3dfc4fefb776a98f8bf.png";